// Estilos compartilhados pelos modais do redesign de Cobrança (gerar boleto,
// relatórios, reprocessar), pra não repetir os mesmos objetos em cada arquivo.
export const modalHeaderProps = {
  fontFamily: "Lexend Deca",
  fontSize: "xl",
  fontWeight: "600",
  borderBottomWidth: "1px",
  borderBottomColor: "gray.200",
  pb: 4,
} as const;

export const formLabelProps = {
  fontSize: "sm",
  fontWeight: "500",
  color: "gray.700",
  mb: 1,
} as const;
